import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { createApolloClient } from 'vue-cli-plugin-apollo/graphql-client'
import store from '@/store'
import { InMemoryCache } from 'apollo-cache-inmemory'

const cache = new InMemoryCache({
  dataIdFromObject: object => object.id
})

// Install the vue plugin
Vue.use(VueApollo)

// Config
const defaultOptions = {
  // You can use `https` for secure connection (recommended in production)
  // httpEndpoint,
  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  // wsEndpoint: process.env.VUE_APP_GRAPHQL_WS || 'ws://localhost:4000/graphql',
  // LocalStorage token
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,

  // Override default apollo link
  // note: don't override httpLink here, specify httpLink options in the
  // httpLinkOptions property of defaultOptions.
  // link: myLink,

  // Override default cache
  cache,
  typeDefs: store.typeDefs,
  resolvers: store.resolvers

  // Override the way the Authorization header is set
  // getAuth: (tokenName) => ...

  // httpLinkOptions: {
  //   credentials: 'include'
  // },
  // Client local data (see apollo-link-state)
  // clientState: { resolvers: store.resolvers, defaults: store.hydrate }
}

// Call this in the Vue app file
export function createProvider(options = {}) {
  // Create apollo client
  const { apolloClient, wsClient } = createApolloClient({
    ...defaultOptions,
    ...options
  })
  apolloClient.wsClient = wsClient

  // Hydrate cache
  cache.writeData({ data: store.hydrate })

  // TODO: query root and write Fragment
  apolloClient.onResetStore(async () => {
    cache.writeData({ data: store.hydrate })
  })

  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        fetchPolicy: 'cache-and-network'
      }
    },
    errorHandler(error) {
      // tslint:disable-next-line: no-console
      console.log(
        '%cError',
        'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;',
        error.message
      )
    }
  })

  return apolloProvider
}
